import React, { useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import bgImage from '../img/ZEAD.jpg';
import side1 from '../img/woman (5).jpeg';
import side2 from '../img/woman (6).jpeg';

const HeroSection = () => {
  const containerRef = useRef(null);
  const [sparks, setSparks] = useState([]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });

  const scale = useTransform(scrollYProgress, [0, 1], [1.5, 0.1]);
  const xLeft = useTransform(scrollYProgress, [0, 1], [-400, 50]);
  const xRight = useTransform(scrollYProgress, [0, 1], [400, -50]);

  // تأثيرات جديدة خاصة بالكلام عشان يصغر ويختفي مع السكرول
  const contentScale = useTransform(scrollYProgress, [0, 0.8], [1, 0.4]);
  const contentOpacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);

  const handleMouseMove = (e) => {
    const newSpark = {
      id: Date.now(),
      x: e.clientX,
      y: e.clientY,
    };
    setSparks((prev) => [...prev.slice(-15), newSpark]);
  };

  return (
    <div className="hero-container" ref={containerRef} onMouseMove={handleMouseMove}>
      <section className="hero-section">
        {/* الصور الجانبية */}
        <motion.img src={side1} className="side-img left" style={{ x: xLeft }} />
        <motion.img src={side2} className="side-img right" style={{ x: xRight }} />

        <div className="hero-bg-wrapper">
          <motion.div className="hero-image" style={{ backgroundImage: `url(${bgImage})`, scale }} />
        </div>

        {/* طبقة الشرارات */}
        <div className="sparks-layer">
          {sparks.map((spark) => (
            <motion.div
              key={spark.id}
              initial={{ opacity: 1, scale: 0.5 }}
              animate={{ opacity: 0, scale: 2 }}
              transition={{ duration: 0.8 }}
              style={{
                position: 'fixed',
                left: spark.x,
                top: spark.y,
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#d31818',
                pointerEvents: 'none',
                zIndex: 10
              }}
            />
          ))}
        </div>

        {/* تم ربط الـ scale و opacity هنا بـ scrollYProgress */}
        <motion.div 
          className="content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
          style={{ 
            scale: contentScale, 
            opacity: contentOpacity 
          }}
        >
          <h1>MAMY BRAND</h1>
          <h2>حان وقت التالق</h2>
          <p className="brand-description">
            تصاميم عصرية تجمع بين الراحة والأناقة لتناسب إطلالتك اليومية وتمنحك الثقة في كل خطوة.
          </p>
          <div className="brand-actions">
<a href="#portfolio-section" className="btn-secondary">استكشف المجموعة</a>
          </div>
        </motion.div>

        {/* الأزرار العائمة */}
        <motion.a 
          href="https://wa.me/201278922244" 
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn whatsapp-btn"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
          whileHover={{ scale: 1.1, rotate: 5 }}
          whileTap={{ scale: 0.95 }}
        >
          <i className="fab fa-whatsapp"></i>
        </motion.a>
      </section>
    </div>
  );
};

export default HeroSection;